import React, { forwardRef } from "react";
import { createUseStyles } from "react-jss";
import { TariffsTable } from "ComponentsUI/TariffsTable";
import { TariffsHeaderRow } from "ComponentsUI/TarifficationM";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "100%",
	},
}));

const TarifficationMWrapper = forwardRef(({ text, children }, ref) => {
	const classes = useStyles();
	const tableHeader = <TariffsHeaderRow text={text} />;
	return (
		<TariffsTable tableHeader={tableHeader}>
			<div ref={ref} className={classes.root}>
				{children}
			</div>
		</TariffsTable>
	);
});

export default TarifficationMWrapper;
